/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { IAppServer } from "../app";
import { IServiceDefinition } from "../services/IServiceDefinition";
import { createSecretsProviderFactory } from "./createSecretsProviderFactory";
import { ISecretsProvider, ISecretsProviderOptions } from "./ISecretsProvider";

export function createSecretsProviderDefinition<
	TOptions extends ISecretsProviderOptions,
	TClass extends ISecretsProvider
>(
	name: string,
	category: string,
	label: string,
	optionsSchema: TGenericBlueprintSchema,
	entityClass: new (config: TOptions, app: IAppServer) => TClass
): IServiceDefinition<TOptions, TClass> {
	return {
		name,
		category,
		label,
		factory: createSecretsProviderFactory(entityClass),
		optionsSchema
	};
}
